import { createApi } from "@reduxjs/toolkit/query/react";

import type { AccountDTO } from "../../../../common/types/AccountDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const accountService = createApi({
  reducerPath: "accountService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Account"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getAccount: builder.query<AccountDTO, { id: string }>({
      query: ({ id }) => `/api/identity/accounts/${id}`,
      providesTags: (account) => [{ type: "Account", id: account?.id }],
    }),
    getAccounts: builder.query<
      Pick<AccountDTO, "id" | "name" | "active" | "properties">[],
      { active?: boolean } | void
    >({
      query: (params) => {
        const queryParams: Record<string, string> = {};
        if (params?.active !== undefined) {
          queryParams["active"] = String(params.active);
        }
        return {
          url: `/api/identity/accounts`,
          params: queryParams,
        };
      },
      providesTags: [{ type: "Account", id: "LIST" }],
    }),
  }),
});

export const { useGetAccountQuery, useGetAccountsQuery } = accountService;
